module.exports = __webpack_public_path__ + "img/our-world-logo-white.5f2f9213.svg";